import React, { useState } from 'react';
import { Box } from '@mui/material';
import AccessoryDashboard from 'components/accessory/AccessoryDashboard';
import AccessoryEdit from 'components/accessory/AccessoryEdit';
import { useNavigate } from 'react-router-dom';

const AccessoriesContainer = () => {
  const [editingAccessory, setEditingAccessory] = useState(null);
  const navigate = useNavigate();

  const handleEditAccessory = (accessory) => {
    setEditingAccessory(accessory);
  };

  const handleCreateAccessory = () => {
    // Navigate to the accessory landing page or show a create form
    // You can customize this based on your app's workflow
    navigate('/accessory');
    
    // Alternatively, if you want to show a creation form instead of navigating:
    // setIsCreatingAccessory(true);
  };



  if (editingAccessory) {
    return (
      <AccessoryEdit 
        accessory={editingAccessory}
        onCancel={() => setEditingAccessory(null)}
      />
    );
  }

  return (
    <AccessoryDashboard 
    onEditAccessory={handleEditAccessory}
    onCreateAccessory={handleCreateAccessory}
     />
  );
};

export default AccessoriesContainer;